import { IBusinessCreditReportState, BusinessCreditReportTypes, REQUEST_BUSINESS_CREDIT_REPORT, RECEIVE_BUSINESS_CREDIT_REPORT } from "./types";

const initialState: IBusinessCreditReportState = { isLoading: false };

export function businessCreditReportReducer(state = initialState, action: BusinessCreditReportTypes): IBusinessCreditReportState {
    if (state === undefined) {
        return initialState;
    }

    switch (action.type) {
        case REQUEST_BUSINESS_CREDIT_REPORT:
            return {
                isLoading: true,
                creditReportData: state.creditReportData,
            };
        case RECEIVE_BUSINESS_CREDIT_REPORT:
            return {
                isLoading: false,
                creditReportData: action.creditReportData,
            };
        default:
            return state;
    }
}
